import React, { useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { VideoIcon, VideoOffIcon, ChevronUpIcon } from "lucide-react";

interface VideoButtonProps {
  enabled: boolean;
  onToggle: () => void;
  devices: MediaDeviceInfo[];
  activeDeviceId: string;
  onDeviceChange: (deviceId: string) => void;
}

const VideoButton: React.FC<VideoButtonProps> = ({
  enabled,
  onToggle,
  devices,
  activeDeviceId,
  onDeviceChange,
}) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: enabled ? "#636365" : "secondary.dark",
            borderRadius: devices.length > 1 ? "20px" : "50%",
            overflow: "hidden",
            "&:hover": {
              backgroundColor: enabled
                ? "rgba(255, 255, 255, 0.2)"
                : "secondary.main",
            },
            transition: "all 0.2s ease",
          }}
        >
          <Box
            onClick={onToggle}
            sx={{
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "white",
            }}
          >
            {enabled ? <VideoIcon size={20} /> : <VideoOffIcon size={20} />}
          </Box>
          {devices.length > 1 && (
            <Box
              onClick={(event) => setMenuAnchor(event.currentTarget)}
              sx={{
                marginRight: "12px",
                cursor: "pointer",
              }}
            >
              <ChevronUpIcon
                size={20}
                style={{
                  strokeWidth: 2,
                  color: "white",
                }}
              />
            </Box>
          )}
        </Box>
      </Box>

      {/* Device Menu */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            backgroundColor: "#2C2C2C",
            backdropFilter: "blur(20px)",
            color: "white",
            minWidth: "200px",
          },
        }}
      >
        {devices.map((device) => (
          <MenuItem
            key={device.deviceId}
            onClick={() => {
              onDeviceChange(device.deviceId);
              setMenuAnchor(null);
            }}
            selected={device.deviceId === activeDeviceId}
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "#636365",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              },
            }}
          >
            {device.label || `Camera ${device.deviceId.slice(0, 5)}...`}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default VideoButton;
